/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  canLoadMoreMessages,
  getActiveConversation,
  getMessages,
  getMessagesFetchStatus,
} from 'src/selectors/chatSelectors';
import { FetchStatus } from 'src/models/Chat';

import ChatMessageRow from './ChatMessageRow';

const ChatMessageList = (props) => {
  const dispatch = useDispatch();
  const { uuid: activeConversationUuid } = useSelector(getActiveConversation);

  const activeMessages = useSelector(getMessages);
  const canLoadMore = useSelector(canLoadMoreMessages);
  const messageFetchStatus = useSelector(getMessagesFetchStatus);

  const [hasScrolledUp, setHasScrolledUp] = useState(false);
  const [loadingMoreMessages, setLoadingMoreMessages] = useState(false);

  const [ref, setRef] = useState(null);
  const [previousScrollHeight, setPreviousScrollHeight] = useState(null);

  // So this is a cool way to keep track of updates to a ref i found in the react docs
  // This callback will fire whenever something in the ref has an update
  // In this scenario we are interested when the scroll height changes so that
  // We can calculate where on the screen the user is after loading more messages
  const chatWindowRef = useCallback((node) => {
    if (
      node &&
      hasScrolledUp &&
      node.scrollHeight !== previousScrollHeight &&
      loadingMoreMessages
    ) {
      ref.scrollTop = ref.scrollHeight - previousScrollHeight;
      setLoadingMoreMessages(false);
    }

    if (node) {
      setPreviousScrollHeight(node.scrollHeight);
    }

    setRef(node);
  });

  useEffect(() => {
    if (!hasScrolledUp && ref) {
      ref.scrollTop = ref.scrollHeight - ref.clientHeight;
    }
  }, [hasScrolledUp, activeMessages]);

  useEffect(() => {
    setPreviousScrollHeight(null);

    if (ref) {
      ref.scrollTop = ref.scrollHeight;
    }

    // this occurs every time a different conversations is selected
    props.onReadConversation();
  }, [activeConversationUuid]);

  const myScroll = async () => {
    if (!ref) {
      return;
    }

    // If they've scrolled to the top and there's more to load, load more
    if (ref.scrollTop < 200 && canLoadMore && messageFetchStatus === FetchStatus.Completed) {
      dispatch.chat.fetchMoreMessages();
      setLoadingMoreMessages(true);
      return;
    }

    setHasScrolledUp(ref.scrollTop + ref.clientHeight !== ref.scrollHeight);
  };

  const items = activeMessages
    .slice()
    .reverse()
    .map((message) => {
      return <ChatMessageRow messageData={message} key={message.uuid} />;
    });

  if (messageFetchStatus === FetchStatus.Failed) {
    return (
      <div className="flex flex-1 justify-center items-center">
        <h3>Something went wrong...</h3>
      </div>
    );
  }

  return (
    <div
      className="p-4 flex-grow h-0 overflow-y-auto border-b border-gray-200 bg-gray-100"
      onScroll={myScroll}
      ref={chatWindowRef}
    >
      {items}
    </div>
  );
};

export default ChatMessageList;
